export const pointrThemedNavbarState = {
  menuAnchor: null as any,
  userActionsMenuAnchor: null as any
}

export type PointrThemedNavbarState = typeof pointrThemedNavbarState
